import type { UserListSortField } from '@klear/user/user-list.wire'

export type UserListGridColDef = {
  sortKeys?: readonly UserListSortField[]
}

export const DELETED_USER_EMAIL_MESSAGE =
  'This email belongs to a deleted user. Restore them to bring back their account and previous roles, then edit them to change organization.'
